import { Box, Image } from "@jewlr/storybook/core"
import loadjs from "loadjs"
import React, { useEffect } from "react"
import styled from "styled-components"

const Container = styled.div`
  min-height: 560px;

  & > *:nth-child(n + 2) {
    display: none;
  }
`

const GiftFinder = () => {
  useEffect(() => {
    const loadSplash = () => {
      window.DIGIOH_API.LIGHTBOX.loadLightbox(
        "4bff0933-0de0-468d-bde1-862cce2dff7d"
      )
    }

    if (window.DIGIOH_API && window.DIGIOH_API.LIGHTBOX) {
      loadSplash()
    } else {
      loadjs(
        [
          `https://www.lightboxcdn.com/vendor/7c3a4ec6-f10d-4926-b14d-64ee5d0a9611/lightbox_speed.js?mb=${new Date().getTime()}`,
        ],
        { async: true, returnPromise: true }
      )
        .then(() => loadSplash())
        .catch((err) => console.log(`Error loading splash page: ${err}`))
    }
  }, [])

  return (
    <Container id="gift-finder-splash">
      <Box minHeight="350px" my={6} textAlign="center">
        <Image
          alt="Loading"
          height="175"
          lazyload={false}
          src={require("images/layout/loadinglarge.gif")}
          width="175"
        />
      </Box>
    </Container>
  )
}

export default GiftFinder
